/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */
import { Alert, AlertTitle, Box, useTheme } from "@mui/material";
import * as React from "react";

import { RobotoDivider } from "@/shared/components";
import { TokensTable, CreateTokenForm } from "@/shared/components/tokens";
import { useListTokens } from "@/shared/domain/tokens/hooks/useListTokens";

import { SettingsPageLayout } from "../SettingsPageLayout";

export const Tokens: React.FC = () => {
  const theme = useTheme();

  const tokensQuery = useListTokens();

  const [errorText, setErrorText] = React.useState<string>();

  return (
    <SettingsPageLayout>
      {errorText && (
        <Alert severity="error">
          <AlertTitle>Token Error</AlertTitle>
          {errorText}
        </Alert>
      )}
      <Box
        sx={{
          paddingBottom: theme.spacing(2),
        }}
      >
        <CreateTokenForm
          refetch={() => {
            void tokensQuery.refetch();
          }}
          setErrorText={setErrorText}
        />
      </Box>
      <Box
        sx={{
          marginLeft: theme.spacing(2),
          marginRight: theme.spacing(2),
        }}
      >
        <RobotoDivider />
      </Box>

      <Box
        sx={{
          paddingTop: theme.spacing(2),
        }}
      >
        <TokensTable
          data={tokensQuery.data}
          loading={tokensQuery.isLoading}
          refetch={() => {
            void tokensQuery.refetch();
          }}
          setErrorText={setErrorText}
        />
      </Box>
    </SettingsPageLayout>
  );
};
